export default "__VITE_ASSET__Mjy94kVB__"